import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { getConfig } from 'utils/config'
import { parse } from 'date-fns'

export const BENEFICIARY_UPLOAD_GET = 'BENEFICIARY_UPLOAD_GET'
export const BENEFICIARY_UPLOAD_RECEIVED = 'BENEFICIARY_UPLOAD_RECEIVED'
export const BENEFICIARY_UPLOAD_GET_ERROR = 'BENEFICIARY_UPLOAD_GET_ERROR'
export const BENEFICIARY_UPLOAD_DELETE_RECEIVED = 'BENEFICIARY_UPLOAD_DELETE_RECEIVED'
export const BENEFICIARY_UPLOAD_DELETE_COMPLETE = 'BENEFICIARY_UPLOAD_DELETE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const beneficiaryUploadReceive = (uploads, locked) => ({
  type: BENEFICIARY_UPLOAD_RECEIVED,
  uploads,
  locked,
})

const mapBeneficiaryUpload = (result) => {
  const docLib = getConfig().BENEFICIARY_UPLOAD
  const docLibLogs = getConfig().BENEFICIARY_UPLOAD_LOG
  const uploaded = result.map(uploads => ({
    itemId: uploads.ItemID,
    path: uploads.URL,
    logPath: (uploads.URL ? uploads.URL.replace(docLib, docLibLogs).replace('.csv', '.log') : ''),
    status: uploads.Status,
    documentName: uploads.Name,
    created: uploads.Created,
    modified: uploads.Modified,
    modifiedDate: parse(uploads.Modified, constants.DATE_FORMAT.SPO_FORMAT, new Date()),
  }))

  return uploaded.sort((a, b) => b.modifiedDate - a.modifiedDate)
}

export function sendNotification(message) {
  return (dispatch) => {
    dispatch(notify(message))
  }
}

export function getBeneficiaryUpload(employeeId) {
  return (dispatch) => {
    dispatch(fetching(BENEFICIARY_UPLOAD_GET))
    agent.Beneficiary.getlockstatus(employeeId).then((locked) => {
      agent.Beneficiary.getuploads().then((uploads) => {
        dispatch(beneficiaryUploadReceive(mapBeneficiaryUpload(uploads), locked))
        // dispatch(notify('Successfully load admin centre'))
      }).catch((rawError) => {
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          // console.warn('Err <getPartnerPlanRatings>: ', error)
          dispatch(fetchingerror(BENEFICIARY_UPLOAD_GET_ERROR))
        }
      })
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerPlanRatings>: ', error)
        dispatch(fetchingerror(BENEFICIARY_UPLOAD_GET_ERROR))
      }
    })
  }
}

export function lockBeneficiary(employeeId, isLocked) {
  return (dispatch) => {
    dispatch(fetching(BENEFICIARY_UPLOAD_GET))
    agent.Beneficiary.lock(employeeId, isLocked)
      .then((result) => {
        dispatch(getBeneficiaryUpload(employeeId))
        dispatch(notify(`Beneficiary status has been ${(isLocked === constants.BENEFICIARY_LOCK ? 'locked' : 'opened')} for update`))
      })
      .catch((rawError) => {
        // console.error('setCurrentOverviewPageActive error', rawError, rawError.stack, window.location)
        console.error('Lock beneficiary error')
        const { error, status, description } = parseError(rawError)

        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify(`Error updating beneficiary to ${(isLocked === constants.BENEFICIARY_LOCK ? 'locked' : 'opened')} status`, 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/beneficiaryUpload.js